import { useEffect } from 'react';
import { PermissionError } from '@shared/scenes/error';
import { MBSentry } from '@shared/util/sentry';

interface ExternalPermissionErrorProps {
  businessId: number;
  channelId: number;
  hasAuthToken: boolean;
}

export function ExternalPermissionError({
  businessId,
  channelId,
  hasAuthToken,
}: ExternalPermissionErrorProps) {
  useEffect(() => {
    if (!import.meta.env.PROD) {
      return;
    }
    MBSentry.breadcrumb({
      message: 'External permission error data',
      category: 'external-form',
      data: { businessId, channelId, hasAuthToken },
    });
    MBSentry.message('External permission error');
  }, [businessId, channelId, hasAuthToken]);

  return <PermissionError />;
}
